import React, { useState } from "react";
import { db } from "../../firebase";
import { BiMap } from "react-icons/bi";
import { FcPhoneAndroid } from "react-icons/fc";
import { SiGmail } from "react-icons/si";
import { FaLinkedinIn, FaTwitter, FaGithub, FaWhatsapp } from "react-icons/fa";

const ContactForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  //handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    db.collection("contacts")
      .add({
        name: name,
        email: email,
        message: message,
      })
      .then(() => {
        alert("Message has been submitted ");
      })
      .catch((error) => {
        alert(error.message);
      });

    setName("");
    setEmail("");
    setMessage("");
  };

  return (
    <div class="content-block" id="contact">
      <div className="common col-md-6 col-md-offset-3">
        <div className="common col-sm-12">
          <h1 className="main-header">Contact Me</h1>
          <div className="common-border"></div>
        </div>
        <p className="main-content">
          I can be contacted on the following platforms.
        </p>
        <div className="contact-icons">
          <ul class="social-icons">
            <li>
              <a href="https://github.com/Jay-dev-creator">
                <FaGithub className="img" />
              </a>
            </li>
            <li>
              <a href="mailto: kgatle280@gmail.com">
                <SiGmail className="img" />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/Kgatle_Jay">
                <FaTwitter className="img" />
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/matome-kgatle-73aaab1b0/">
                <FaLinkedinIn className="img" />
              </a>
            </li>
            <li>
              <a href="https://api.whatsapp.com/send?phone=0716488958">
                <FaWhatsapp className="img" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="overlay-3">
        <div class="block-content text-center">
          <div class="container">
            <div class="row">
              <div class="col-md-6 wow animated fadeInLeft">
                <header class="block-heading cleafix text-center">
                  <h3>Get in touch</h3>
                </header>
                <form class="contact-form" onSubmit={handleSubmit}>
                  <input
                    type="text"
                    name="name"
                    placeholder="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  ></input>
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  ></input>
                  <textarea
                    rows="5"
                    name="message"
                    placeholder="Message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  ></textarea>
                  <input type="submit" value="Submit" />
                </form>
              </div>
              <div class="col-md-6 wow fadeInRight">
                <div class="row">
                  <div class="col-md-12">
                    <div class="contact-info">
                      <div class="clearfix">
                        <p>
                          <BiMap size={40} className="p-1" />
                          <strong> Address:</strong> Chuenespoort, Polokwane
                          0700.
                        </p>
                      </div>
                      <div class="clearfix">
                        <a
                          href="tel:+27716488958"
                          className="text-light text-decoration-none"
                        >
                          <p>
                            <FcPhoneAndroid size={40} className="p-1" />
                            <strong> Cell No:</strong> +2771-648-8958{" "}
                          </p>
                        </a>
                      </div>
                      <div class="clearfix">
                        <div class="rotated-icon"></div>
                        <a
                          href="mailto: kgatle280@gmail.com"
                          className="text-light text-decoration-none"
                        >
                          <p>
                            <SiGmail size={40} className="p-1" />
                            <strong> Email:</strong> kgatle280@gmail.com
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
